import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
import axios from "axios";
import { toast } from "react-toastify";
//** GET USER CARDS
export const getUserCard = createAsyncThunk(
  "user/getUserCard",
  async (_, { rejectWithValue }) => {
    try {
      const result = await axios.get("get-user-cards", {
        withCredentials: true,
      });
      return result?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

//** ADD NEW USER CARD
// const {name, number, expiry, cvc, cardType, subscriptionId, defaultCard} = req.body;
export const addUserCard = createAsyncThunk(
  "user/addUserCard",
  async (data: object, { rejectWithValue }) => {
    try {
      const result = await axios.post("create-user-payment-token", data, {
        withCredentials: true,
      });
      return result?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

//** DELETE USER CARD
//** DELETE USER CARD
// const {id} = req.body;
export const deleteUserCard = createAsyncThunk(
  "user/deleteUserCard",
  async (id: string, { rejectWithValue }) => {
    try {
      const result = await axios.post(
        "delete-user-payment-token",
        { id },
        {
          withCredentials: true,
        }
      );
      return result?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

//** CREATE MANDATE
// const {iban,companyName,emailAddress,city,countryCode,zip,street,firstName,surname,title,subscriptionID} = req.body;
export const addMandate = createAsyncThunk(
  "user/addMandate",
  async (data: object, { rejectWithValue }) => {
    try {
      const result = await axios.post("create-mandate-sub", data, {
        withCredentials: true,
      });
      return result?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);
export const checkUserMandateSub = createAsyncThunk(
  "user/checkMandateSub",
  async (subscriptionId: string, { rejectWithValue }) => {
    try {
      const result = await axios.get(`check-mandate-sub/${subscriptionId}`, {
        withCredentials: true,
      });
      if (result.data.Success) {
        toast.success(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(result.data.Description, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      return result?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);
//** GET MANDATE
export const getUserMandate = createAsyncThunk(
  "user/getUserMandate",
  async (subscriptionID: string, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        "get-user-mandate",

        {
          withCredentials: true,
          params: {
            subscriptionID
          }
        }
      );
      return result?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

//** DELETE MANDATE 
export const updateSubMandateStatus = createAsyncThunk(
  "user/updateSubMandateStatus",
  async (mandateId: any, { rejectWithValue }) => {
    try {
      const result = await axios.post(
        "update-status-mandate-sub",
        { mandateId },
        {
          withCredentials: true,
        }
      );
      return result?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

const cardSlice = createSlice({
  name: "card",
  initialState: {
    success: false,
    description: null as string | null,
    cards: [] as any[],
    mandate: [] as any[],
  },
  reducers: {
    clearErrors: (state) => {
      state.description = null;
    },
  },
  extraReducers: (builder) => {
    builder
      //** getUserCard
      .addCase(getUserCard.pending, (state) => {
        state.success = false;
        state.description = null;
        state.cards = [];
      })
      .addCase(getUserCard.fulfilled, (state, action) => {
        state.success = true;
        state.description = null;
        state.cards = action.payload.Cards;
      })
      .addCase(getUserCard.rejected, (state: any, action: any) => {
        state.success = false;
        state.description = action.payload.Description;
        state.cards = [];
      })
      //** addUserCard
      .addCase(addUserCard.pending, (state) => {
        state.success = false;
        state.description = null;
      })
      .addCase(addUserCard.fulfilled, (state, action) => {
        state.success = true;
        state.description = action.payload.Description;
        state.cards = action.payload.Cards;
      })
      .addCase(addUserCard.rejected, (state: any, action: any) => {
        state.success = false;
        state.description = action.payload.Description;
        if (action.payload?.Cards) {
          state.cards = action.payload.Cards;
        }
      })
      //** deleteUserCard
      .addCase(deleteUserCard.pending, (state) => {
        state.success = false;
        state.description = null;
      })
      .addCase(deleteUserCard.fulfilled, (state, action) => {
        state.success = true;
        state.description = action.payload.Description;
        state.cards = action.payload.Cards;
      })
      .addCase(deleteUserCard.rejected, (state: any, action: any) => {
        state.success = false;
        state.description = action.payload.Description;
      })
      //** get user mandate
      .addCase(getUserMandate.pending, (state) => {
        state.success = false;
        state.description = null;
        state.mandate = [];
      })
      .addCase(getUserMandate.fulfilled, (state, action) => {
        state.success = true;
        state.description = null;
        state.mandate = action.payload.Mandate;
      })
      .addCase(getUserMandate.rejected, (state: any, action: any) => {
        state.success = false;
        state.description = null;
        state.mandate = [];
      })
      // ** create user mandate
      .addCase(addMandate.pending, (state) => {
        state.success = false;
        state.description = null;
        state.mandate = [];
      })
      .addCase(addMandate.fulfilled, (state, action) => {
        state.success = true;
        state.description = null;
        state.mandate = action.payload.Mandate;
      })
      .addCase(addMandate.rejected, (state: any, action: any) => {
        state.success = false;
        state.description = action.payload.Description;
        state.mandate = [];
      })

      // ** check user mandate
      .addCase(checkUserMandateSub.pending, (state) => {
        state.success = false;
        state.description = null;
        state.mandate = [];
      })
      .addCase(checkUserMandateSub.fulfilled, (state, action) => {
        state.success = true;
        state.description = action.payload.description;
        // state.mandate = action.payload.Mandate;
      })
      .addCase(checkUserMandateSub.rejected, (state: any, action: any) => {
        state.success = false;
        state.description = action.payload.Description;
        state.mandate = [];
      })
      // ** delete sub mandate
      .addCase(updateSubMandateStatus.pending, (state) => {
        state.success = false;
        state.description = null;
      })
      .addCase(updateSubMandateStatus.fulfilled, (state, action) => {
        state.success = true;
        state.description = null;
        state.mandate = [];
      })
      .addCase(updateSubMandateStatus.rejected, (state: any, action: any) => {
        state.success = false;
        state.description = action.payload.Description;
      });
  },
});

export default cardSlice.reducer;
